import { render, staticRenderFns } from "./ContentOfferIndex.vue?vue&type=template&id=e0b84dc6&"
import script from "./ContentOfferIndex.vue?vue&type=script&lang=js&"
export * from "./ContentOfferIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports